import axios from "axios";
import {
  OPENSEA_BASE_URL,
  NFT_STORAGE_KEY,
  NFT_STORAGE_ENDPOINT,
} from "@/common/constants";
import ERC721Interface from "./ERC721Interface";
import IpfsInterface from "./IpfsInterface";
import AssetInterface from "./AssetInterface";
import CollectionsInterface from "@/services/CollectionsInterface";
import UserInterface from "@/services/UserInterface";

const createClient = () => {
  const c = axios.create({
    baseURL: OPENSEA_BASE_URL,
    params: {},
  });
  c.interceptors.request.use((config) => {
    config.params = config.params || {};
    if (!config.params["format"]) {
      config.params["format"] = "json";
    }
    return config;
  });
  return c;
};

const erc721Interface = new ERC721Interface();
const ipfsInterface = new IpfsInterface(NFT_STORAGE_KEY, NFT_STORAGE_ENDPOINT);
const assetInterface = new AssetInterface(createClient());
const collectionsInterface = new CollectionsInterface(createClient());
const userInterface = new UserInterface(createClient());

export {
  ipfsInterface,
  erc721Interface,
  assetInterface,
  collectionsInterface,
  userInterface,
};
